import type { Feedback, OCCompany, Ownerships } from 'bundles/connect/types';
import { saveLlcData } from '../../../helpers/local_storage';
import {
  UPDATE_OFF_MARKET_PROPERTY_AI_COMPANY_FEEDBACK,
  UPDATE_OFF_MARKET_PROPERTY_OWNERSHIP_FEEDBACK
} from '../actions/ai_related_companies';
import {
  ADD_OFF_MARKET_PROPERTY_OWNERSHIP,
  CLEAR_OFF_MARKET_PROPERTY,
  DELETE_OFF_MARKET_PROPERTY_OWNERSHIP,
  SET_OFF_MARKET_PROPERTY,
  SET_OFF_MARKET_PROPERTY_OWNER_CONTACT_METHOD_SCORE,
  SET_OFF_MARKET_PROPERTY_VERIFIED_OWNER,
  UPDATE_OFF_MARKET_PROPERTY,
  UPDATE_OFF_MARKET_PROPERTY_CONTACT
} from '../actions/off_market_property';

const initialState: OffMarketPropertyStateType = {
  propertyId: '',
  aiRelatedCompanies: [],
};

type OffMarketPropertyStateType = {
  propertyId: string;
  aiRelatedCompanies: {
    id: number;
    feedback: Feedback;
  }[];
  owners?: Ownerships[];
  ocCompany?: OCCompany;
}

export default function(state = initialState, action): OffMarketPropertyStateType {
  switch (action.type) {
  case SET_OFF_MARKET_PROPERTY:
    return action.payload;
  case UPDATE_OFF_MARKET_PROPERTY:
    if (state.propertyId && action.payload.ocCompany) {
      saveLlcData(state.propertyId, action.payload.ocCompany);
    }
    return {
      ...state,
      ...action.payload
    };
  case UPDATE_OFF_MARKET_PROPERTY_AI_COMPANY_FEEDBACK: {
    const updatedAiRelatedCompanies = state.aiRelatedCompanies.map((company) => {
      return company.id === action.payload.aiCompanyId
        ? { ...company, feedback: action.payload.feedback }
        : company;
    });

    return { ...state, aiRelatedCompanies: updatedAiRelatedCompanies };
  }
  case UPDATE_OFF_MARKET_PROPERTY_OWNERSHIP_FEEDBACK: {
    const updatedOwners = state.owners?.map((owner) => {
      return owner.id === action.payload.ownershipId
        ? { ...owner, feedback: action.payload.feedback }
        : owner;
    });

    return { ...state, owners: updatedOwners };
  }
  case CLEAR_OFF_MARKET_PROPERTY:
    return initialState;
  case SET_OFF_MARKET_PROPERTY_VERIFIED_OWNER: {
    const updatedOwners = state.owners?.map((owner) => {
      return owner.id === action.payload.ownerId
        ? { ...owner, verified: action.payload.verified }
        : owner;
    });
    return { ...state, owners: updatedOwners };
  }
  case SET_OFF_MARKET_PROPERTY_OWNER_CONTACT_METHOD_SCORE: {
    const updatedOwners = state.owners?.map((owner) => {
      if (owner.id === action.payload.ownerId) {
        const { contactMethodKey, contactMethodId, newScore } = action.payload;
        return {
          ...owner,
          contact: {
            ...owner.contact,
            [contactMethodKey]: owner.contact[contactMethodKey].map(cm => ({
              ...cm,
              connectRankScore: cm.id === contactMethodId ? newScore : cm.connectRankScore
            }))
          }
        };
      }
      return owner;
    });
    return { ...state, owners: updatedOwners };
  }
  case DELETE_OFF_MARKET_PROPERTY_OWNERSHIP: {
    const updatedOwners = state.owners?.filter(owner => owner.id !== action.payload.ownerId);
    return { ...state, owners: updatedOwners };
  }
  case ADD_OFF_MARKET_PROPERTY_OWNERSHIP: {
    const updatedOwners = [action.payload, ...(state.owners || [])];
    return { ...state, owners: updatedOwners };
  }
  case UPDATE_OFF_MARKET_PROPERTY_CONTACT: {
    const updatedOwners = state.owners?.map((owner) => {
      return owner.contact.id === action.payload.id
        ? {
          ...owner,
          contact: {
            ...owner.contact,
            ...action.payload
          }
        }
        : owner;
    });
    return { ...state, owners: updatedOwners };
  }
  default:
    return state;
  }
}
